module.exports = __webpack_public_path__ + "img/spinner.8ee7fcb9.gif";